// Centralized axios client.
// - Uses SERVER_URL from src/config.js
// - Automatically attaches Bearer token from localStorage (authToken)

import axios from 'axios';
import { SERVER_URL } from './config';

const api = axios.create({
  baseURL: SERVER_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
